"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetedTurmoil = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var OrOptions_1 = require("../../../inputs/OrOptions");
var constants_1 = require("../../../constants");
var SelectOption_1 = require("../../../inputs/SelectOption");
var RemoveOceanTile_1 = require("../../../deferredActions/RemoveOceanTile");
var CardRequirements_1 = require("../../CardRequirements");
var PartyName_1 = require("../../../turmoil/parties/PartyName");
var LogHelper_1 = require("../../../LogHelper");
var TargetedTurmoil = (function (_super) {
    __extends(TargetedTurmoil, _super);
    function TargetedTurmoil() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.TARGETED_TURMOIL,
            cost: 4,
            tags: [Tags_1.Tags.SPACE],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.party(PartyName_1.PartyName.REDS); }),
            metadata: {
                cardNumber: 'L307',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.minus().temperature(1).or().oceans(1).or().br.oxygen(1).or().venus(1);
                }),
                description: 'Requires that Reds are ruling or that you have 2 delegates there. Decrease any non-maxed global parameter by one.',
            },
        }) || this;
    }
    TargetedTurmoil.prototype.canPlay = function (player) {
        return _super.prototype.canPlay.call(this, player) && ((player.game.getTemperature() > constants_1.MIN_TEMPERATURE && player.game.getTemperature() < constants_1.MAX_TEMPERATURE) ||
            (player.game.getOxygenLevel() > constants_1.MIN_OXYGEN_LEVEL && player.game.getOxygenLevel() < constants_1.MAX_OXYGEN_LEVEL) ||
            (player.game.board.getOceansOnBoard() > 0 && player.game.board.getOceansOnBoard() < constants_1.MAX_OCEAN_TILES) ||
            (player.game.gameOptions.venusNextExtension &&
                player.game.getVenusScaleLevel() > constants_1.MIN_VENUS_SCALE && player.game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE));
    };
    TargetedTurmoil.prototype.play = function (player) {
        var orOptions = new OrOptions_1.OrOptions();
        if (player.game.getTemperature() > constants_1.MIN_TEMPERATURE && player.game.getTemperature() < constants_1.MAX_TEMPERATURE) {
            orOptions.options.push(new SelectOption_1.SelectOption('Decrease Temperature', 'Decrease Temperature', function () {
                player.game.increaseTemperature(player.game.getPlayers()[0], -1);
                LogHelper_1.LogHelper.logTargetedTurmoilDecrease(player, 'Temperature');
                return undefined;
            }));
        }
        if (player.game.getOxygenLevel() > constants_1.MIN_OXYGEN_LEVEL && player.game.getOxygenLevel() < constants_1.MAX_OXYGEN_LEVEL) {
            orOptions.options.push(new SelectOption_1.SelectOption('Decrease Oxygen level', 'Decrease O2', function () {
                player.game.increaseOxygenLevel(player.game.getPlayers()[0], -1);
                LogHelper_1.LogHelper.logTargetedTurmoilDecrease(player, 'Oxygen');
                return undefined;
            }));
        }
        var oceansPlaced = player.game.board.getOceansOnBoard();
        if (oceansPlaced > 0 && oceansPlaced < constants_1.MAX_OCEAN_TILES) {
            orOptions.options.push(new SelectOption_1.SelectOption('Remove Ocean', 'Remove Ocean', function () {
                player.game.defer(new RemoveOceanTile_1.RemoveOceanTile(player, 'Targeted Turmoil - Remove an Ocean tile from the board'));
                LogHelper_1.LogHelper.logTargetedTurmoilDecrease(player, 'Ocean');
                return undefined;
            }));
        }
        if (player.game.gameOptions.venusNextExtension &&
            player.game.getVenusScaleLevel() > constants_1.MIN_VENUS_SCALE &&
            player.game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE) {
            orOptions.options.push(new SelectOption_1.SelectOption('Decrease Venus level', 'Decrease Venus', function () {
                player.game.increaseVenusScaleLevel(player.game.getPlayers()[0], -1);
                LogHelper_1.LogHelper.logTargetedTurmoilDecrease(player, 'Venus');
                return undefined;
            }));
        }
        if (orOptions.options.length === 0)
            return undefined;
        if (orOptions.options.length === 1)
            return orOptions.options[0].cb();
        return orOptions;
    };
    return TargetedTurmoil;
}(Card_1.Card));
exports.TargetedTurmoil = TargetedTurmoil;
//# sourceMappingURL=TargetedTurmoil.js.map